import i18n from "src/i18n";

export function convertMessageCodeToMessage(messageCode){
    let codes = messageCode.match(/(?:\|)[^\|\|]*?(?:\|)/g) || [];
    let message = messageCode;
    for(let i=0; i<codes.length; i++){
        message = message.replace(codes[i], i18n.t(codes[i].replace(/\|/g, '')));
    }
    return message;
}